<template>
  <v-container
    fluid
    class="d-flex flex-column"
    :style="{
      backgroundImage: 'url(' + require('@/assets/beon.jpg') + ')',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      height: '100vh',
      width: '100vw',
      margin: '0',
      padding: '0',
      overflow: 'hidden',
    }"
  >
    <v-layout>
      <v-flex>
        <v-row justify="center" align="center">
          <v-col cols="12" class="d-flex flex-column align-center text-center">
            <v-row justify="center" align="center" class="mt-14 my-8">
              <v-col cols="2" justify="center" align="center" class="pr-0">
                <v-img
                  contain
                  :src="require('@/assets/VP_sin_fondo.png')"
                  :class="{
                    'logo-class': $vuetify.breakpoint.smAndUp,
                    'logo-class-small': $vuetify.breakpoint.smAndDown,
                  }"
                />
              </v-col>
              <v-col cols="2" justify="center" align="center" class="pl-0">
                <v-img
                  contain
                  src="img/beonit.png"
                  :class="{
                    'logo-class': $vuetify.breakpoint.smAndUp,
                    'logo-class-small': $vuetify.breakpoint.smAndDown,
                  }"
                />
              </v-col>
            </v-row>

            <v-card v-if="!isForgotPassword" class="mt-12 mx-4 pa-6" width="700">
              <v-card-title class="justify-center mb-6">
                <h2 class="error-title">Error!</h2>
              </v-card-title>

              <h6>The page is currently unavailable. Please, try again later.</h6>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ErrorPage',
};
</script>
